"use strict";
/// <reference path="../../../Trillium.UI/TypeScript/Models/Website/DocumentLibraryViewModel.tsx"/>
/// <reference path="../../../Trillium.UI//TypeScript/Models/General/API/UmbracoApiRequestResult.tsx"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var DocumentLibraryService_1 = __importDefault(require("../../../Trillium.UI/TypeScript/Services/DocumentLibrary/DocumentLibraryService"));
var ListDocuments_1 = __importDefault(require("./ListDocuments"));
var ListFolders_1 = __importDefault(require("./ListFolders"));
var SearchBox_1 = __importDefault(require("./SearchBox"));
var FileUploader_1 = __importDefault(require("./FileUploader"));
var core_1 = require("@material-ui/core");
var FolderListModal_1 = __importDefault(require("./FolderListModal"));
var service = new DocumentLibraryService_1.default();
var DocumentLibraryComponent = /** @class */ (function (_super) {
    __extends(DocumentLibraryComponent, _super);
    function DocumentLibraryComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.retrieveFoldersAndFiles = function (folderUrl) { return __awaiter(_this, void 0, void 0, function () {
            var response, res, sortedFolder;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState(__assign(__assign({}, this.state), { loading: true }));
                        return [4 /*yield*/, service.getFolderWithRelatedItems(this.props.MembershipNumber, folderUrl.Name)];
                    case 1:
                        response = _a.sent();
                        if (response.Success) {
                            res = response.Result;
                            sortedFolder = res.sort(function (a, b) {
                                var aName = a.Name.toLowerCase().replace(' ', '');
                                var bName = b.Name.toLowerCase().replace(' ', '');
                                return aName > bName ? 1 : aName < bName ? -1 : 0;
                            });
                            this.setState(__assign(__assign({}, this.state), { loading: false, isInFolder: !folderUrl.Name ? true : false, ParentFolder: folderUrl.Name, currentFolderUrl: folderUrl.Url, Items: response.Result, folderList: !folderUrl.Name ? sortedFolder : this.state.folderList, alertModal: { open: false, type: '', message: '', error: false }, selectedDocuments: [], serchTerms: '', isInSerch: false }), function () { _this.state.currentOrder === 'date' ? _this.orderByDate() : _this.orderByName(); });
                        }
                        else
                            this.setState(__assign(__assign({}, this.state), { loading: false }));
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onSerchChange = function (terms) {
            _this.setState(__assign(__assign({}, _this.state), { serchTerms: terms }));
        };
        _this.searchItems = function () { return __awaiter(_this, void 0, void 0, function () {
            var matchDoc, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.state.serchTerms && this.state.currentFolderUrl)) return [3 /*break*/, 1];
                        matchDoc = this.state.Items.filter(function (d) { return d.Name.toLowerCase().includes(_this.state.serchTerms.toLowerCase()); });
                        this.setState(__assign(__assign({}, this.state), { isInSerch: true, ParentFolder: this.state.serchTerms, Items: matchDoc }));
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, service.getsearchFiles(this.state.serchTerms, this.props.MembershipNumber, true)];
                    case 2:
                        response = _a.sent();
                        if (response.Success) {
                            this.setState(__assign(__assign({}, this.state), { isInFolder: false, isInSerch: true, 
                                // ParentFolder: this.state.serchTerms,
                                Items: response.Result }), function () { _this.state.currentOrder === 'date' ? _this.orderByDate() : _this.orderByName(); });
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.orderByDate = function () {
            if (_this.state.isInFolder) {
                return;
            }
            var items = [];
            if (_this.state.orderByDateDir === 'Ascending') {
                items = _this.state.Items.sort(function (a, b) {
                    return a.Modified < b.Modified ? 1 : a.Modified > b.Modified ? -1 : 0;
                });
                _this.setState(__assign(__assign({}, _this.state), { Items: items, orderByDateDir: 'Descending', currentOrder: 'date' }));
            }
            else {
                items = _this.state.Items.sort(function (a, b) {
                    return a.Modified < b.Modified ? -1 : a.Modified > b.Modified ? 1 : 0;
                });
                _this.setState(__assign(__assign({}, _this.state), { Items: items, orderByDateDir: 'Ascending', currentOrder: 'date' }));
            }
        };
        _this.orderByName = function () {
            if (_this.state.isInFolder) {
                return;
            }
            var items = [];
            if (_this.state.orderByNameDir === 'Ascending') {
                items = _this.state.Items.sort(function (a, b) {
                    var aName = a.Name.toLowerCase().replace(' ', '');
                    var bName = b.Name.toLowerCase().replace(' ', '');
                    return aName < bName ? 1 : aName > b.Name ? -1 : 0;
                });
                _this.setState(__assign(__assign({}, _this.state), { Items: items, orderByNameDir: 'Descending', currentOrder: 'name' }));
            }
            else {
                items = _this.state.Items.sort(function (a, b) {
                    var aName = a.Name.toLowerCase().replace(' ', '');
                    var bName = b.Name.toLowerCase().replace(' ', '');
                    return aName < bName ? -1 : aName > bName ? 1 : 0;
                });
                _this.setState(__assign(__assign({}, _this.state), { Items: items, orderByNameDir: 'Ascending', currentOrder: 'name' }));
            }
        };
        _this.changeSelectList = function (list) {
            _this.setState(__assign(__assign({}, _this.setState), { selectedDocuments: list }));
        };
        _this.cancelSelectedDoc = function () {
            _this.setState(__assign(__assign({}, _this.state), { selectedDocuments: [] }));
        };
        _this.moveDocumentFile = function (fileUrls, newFolderUrl) { return __awaiter(_this, void 0, void 0, function () {
            var response, folderName;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, service.moveFiles(fileUrls, newFolderUrl)];
                    case 1:
                        response = _c.sent();
                        if (response.Success) {
                            folderName = (_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a.currentFolderUrl) === null || _b === void 0 ? void 0 : _b.split('/').pop();
                            this.setState(__assign(__assign({}, this.state), { alertModal: { open: false, type: '', message: '' }, moveModalOpen: false, selectedDocuments: [] }));
                            if (folderName)
                                this.retrieveFoldersAndFiles({ Name: folderName, Url: this.state.currentFolderUrl });
                            else if (this.state.serchTerms)
                                this.searchItems();
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onFolderSelect = function (folder) {
            _this.setState(__assign(__assign({}, _this.state), { moveFolderData: folder }));
        };
        _this.moveMultipleDoc = function () { return __awaiter(_this, void 0, void 0, function () {
            var folderDocList_1, anySame_1, moveList;
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(((_a = this.state) === null || _a === void 0 ? void 0 : _a.Items.length) && this.state.selectedDocuments)) return [3 /*break*/, 2];
                        return [4 /*yield*/, service.getFolderWithRelatedItems(this.props.MembershipNumber, this.state.moveFolderData.Name)];
                    case 1:
                        folderDocList_1 = _b.sent();
                        anySame_1 = false;
                        moveList = this.state.Items.map(function (d) {
                            folderDocList_1.Result.forEach(function (f) {
                                if (_this.state.selectedDocuments.includes(d.Id) && f.Name === d.Name)
                                    anySame_1 = true;
                            });
                            if (_this.state.selectedDocuments.includes(d.Id))
                                return d.Url;
                            else
                                return;
                        }).filter(function (a) { return a; });
                        if (!anySame_1) {
                            this.moveDocumentFile(moveList, this.state.moveFolderData.Url);
                        }
                        else
                            this.setState(__assign(__assign({}, this.state), { alertModal: { open: true, type: 'move', message: this.props.DocumentLibraryMoveErrorMessage, sortList: moveList, error: false } }));
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        _this.deleteFiles = function () {
            _this.setState(__assign(__assign({}, _this.state), { alertModal: { open: true, type: 'delete', message: _this.props.DocumentLibraryAlertMessage, error: false } }));
        };
        _this.deleteMultipleDoc = function () { return __awaiter(_this, void 0, void 0, function () {
            var error_1, moveList, res, folderName;
            var _this = this;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!(((_a = this.state) === null || _a === void 0 ? void 0 : _a.Items.length) && this.state.selectedDocuments)) return [3 /*break*/, 3];
                        error_1 = [];
                        moveList = this.state.Items.map(function (d) {
                            if (_this.state.selectedDocuments.includes(d.Id)) {
                                if (d.Attributes && JSON.parse(d.Attributes).length) {
                                    error_1.push(d.Id);
                                    return null;
                                }
                                else
                                    return d.Url;
                            }
                            else
                                return;
                        }).filter(function (a) { return a; });
                        if (!!error_1.length) return [3 /*break*/, 2];
                        return [4 /*yield*/, service.deleteDocumentFile(moveList)];
                    case 1:
                        res = _d.sent();
                        if (res.Success) {
                            this.cancelSelectedDoc();
                            this.alertModalClose();
                            if ((_b = this.state) === null || _b === void 0 ? void 0 : _b.currentFolderUrl) {
                                folderName = (_c = this.state) === null || _c === void 0 ? void 0 : _c.currentFolderUrl.split('/').pop();
                                this.retrieveFoldersAndFiles({ Name: folderName, Url: this.state.currentFolderUrl });
                            }
                            else if (this.state.serchTerms)
                                this.searchItems();
                        }
                        else
                            this.setState(__assign(__assign({}, this.state), { alertModal: __assign(__assign({}, this.state.alertModal), { message: "Something went wrong", error: true }) }));
                        return [3 /*break*/, 3];
                    case 2:
                        this.setState(__assign(__assign({}, this.state), { errorList: error_1, alertModal: { open: false, type: '', message: '' } }));
                        _d.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.continueOnAlert = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.state.alertModal.type === 'delete')
                            this.deleteMultipleDoc();
                        if (!(this.state.alertModal.type === 'move')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.moveDocumentFile(this.state.alertModal.sortList, this.state.moveFolderData.Url)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        _this.onBack = function () {
            _this.retrieveFoldersAndFiles({ Name: '' });
        };
        _this.moveFileModalOpen = function () {
            _this.setState(__assign(__assign({}, _this.state), { moveModalOpen: true }));
        };
        _this.moveFileModalClose = function () {
            _this.setState(__assign(__assign({}, _this.state), { moveModalOpen: false }));
        };
        _this.alertModalOpen = function () {
            _this.setState(__assign(__assign({}, _this.state), { alertModal: { open: true, type: '', message: '', error: false } }));
        };
        _this.alertModalClose = function () {
            _this.setState(__assign(__assign({}, _this.state), { alertModal: { open: false, type: '', message: '' } }));
        };
        _this.onMoveCancel = function () {
            _this.setState(__assign(__assign({}, _this.state), { moveModalOpen: false, selectedDocuments: [] }));
        };
        _this.state = {
            loading: true,
            isInFolder: true,
            isInSerch: false,
            currentFolderUrl: '',
            orderByNameDir: 'Ascending',
            orderByDateDir: 'Descending',
            currentOrder: 'date',
            selectedDocuments: [],
            moveModalOpen: false,
            alertModal: { open: false, type: '', message: '' },
            errorList: [],
            Items: [],
            folderList: [],
            serchTerms: '',
        };
        _this.orderByName = _this.orderByName.bind(_this);
        _this.orderByDate = _this.orderByDate.bind(_this);
        return _this;
    }
    DocumentLibraryComponent.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.retrieveFoldersAndFiles({ Name: '' });
                return [2 /*return*/];
            });
        });
    };
    DocumentLibraryComponent.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d;
        var response = this.state && this.state.Items ? this.state.Items : [];
        var renderListItems = function () {
            if (_this.state) {
                if (_this.state.isInFolder) {
                    return react_1.default.createElement(ListFolders_1.default, { HeaderText: _this.props.DocumentLibraryComponentHeader, Folders: _this.state.folderList.filter(function (x) { return x.Type === 'folder'; }), onFolderclick: _this.retrieveFoldersAndFiles, selectFolder: '' });
                }
                else if (_this.state.Items) {
                    return react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(ListDocuments_1.default, { MembershipNumber: _this.props.MembershipNumber, FolderList: _this.state.folderList, HeaderText: _this.state.ParentFolder, Documents: response.filter(function (x) { return x.Type !== 'folder'; }), RetrieveDocuments: _this.retrieveFoldersAndFiles, onSelectChange: _this.changeSelectList, SearchItems: _this.searchItems, multiselectedDoc: _this.state.selectedDocuments, errorList: _this.state.errorList, documentTitle: _this.props.DocumentLibraryDocumentFound, documentsTitle: _this.props.DocumentLibraryDocumentsFound, deleteErrorMessage: _this.props.DocumentLibraryDeleteErrorMessage, moveButton: _this.props.DocumentLibraryMoveButton, cancleButton: _this.props.DocumentLibraryCancelButton, continueButton: _this.props.DocumentLibraryContinueButton, deleteButton: _this.props.DocumentLibraryDeleteButton, saveButton: _this.props.DocumentLibrarySaveButton, editButton: _this.props.DocumentLibraryEditButton, assignToText: _this.props.DocumentLibraryAssignedTo, emptyFolderHeader: _this.props.DocumentLibraryEmptyFolderFirstText, emptyFoldersecondHeader: _this.props.DocumentLibraryEmptyFolderSecondText, moveFolderheader: _this.props.DocumentLibraryMoveDocumentHeader, areYouSure: _this.props.DocumentLibraryAreYouSure, alertMessage: _this.props.DocumentLibraryAlertMessage, editAlertMessage: _this.props.DoucmentLibraryEditAlertMessage, sameErrorMessage: _this.props.DocumentLibrarySameNameErrorMessage, isTrainee: _this.props.isTrainee, moveErrorMessage: _this.props.DocumentLibraryMoveErrorMessage }));
                }
            }
        };
        return (react_1.default.createElement("div", { className: 'ipd-portal' }, !this.state.loading ? react_1.default.createElement(react_1.default.Fragment, null,
            !this.props.isTrainee && this.state.isInFolder && react_1.default.createElement("a", { className: "btn btn-primary", onClick: function () { return history.back(); } }, "< Back"),
            react_1.default.createElement("div", { className: 'card border-0' }, !this.state.isInFolder ? react_1.default.createElement("a", { className: "mt-2 mt-md-0 btn btn-primary-outline col-2 mb-4", onClick: function () { return _this.onBack(); } }, this.props.DocumentLibraryBackButton) : null),
            react_1.default.createElement(SearchBox_1.default, { SearchTerm: this.state.serchTerms, RootFolder: "", PlaceHolder: this.props.DocumentLibrarySerchPlaceholder, SearchItems: this.searchItems, onSerchChange: this.onSerchChange },
                react_1.default.createElement(react_1.default.Fragment, null, !this.state.isInFolder && (!this.state.isInSerch || this.state.currentFolderUrl) && this.props.isTrainee ? react_1.default.createElement(FileUploader_1.default, { label: "Upload file", maxFileSizeInBytes: 10000000, multiple: false, folderUrl: this.state.currentFolderUrl, parentFolder: this.state.ParentFolder, refresh: this.retrieveFoldersAndFiles, uploadNewDocument: this.props.DocumentLibraryUploadNewDocument, minMaxText: this.props.DocumentLibraryMinMaxFileText, fileTypeMessage: this.props.DocumentLibraryUploadFileTypes, removeButton: this.props.DocumentLibraryRemoveButton, uploadButton: this.props.DocumentLibraryUploadButton, cancleButton: this.props.DocumentLibraryCancelButton }) : null)),
            this.state.Items && this.state.Items.length ? (react_1.default.createElement("div", { className: "row mt-5" },
                react_1.default.createElement("div", { className: "col ml-3 pl-0" }, this.state.selectedDocuments.length ?
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("a", { className: "btn btn-primary btn-primary-outline", onClick: this.cancelSelectedDoc }, this.props.DocumentLibraryCancelButton),
                        react_1.default.createElement("a", { className: "btn btn-primary btn-primary-outline mx-2", onClick: this.moveFileModalOpen }, this.props.DocumentLibraryMoveButton),
                        react_1.default.createElement("a", { className: "btn btn-danger", onClick: this.deleteFiles }, this.props.DocumentLibraryDeleteButton))
                    : null),
                this.state.ParentFolder != "" && react_1.default.createElement("div", { className: "sort-bar d-flex flex-row-reverse mr-3" },
                    react_1.default.createElement("div", { className: "sort-arrow " + (this.state.orderByNameDir === 'Ascending' ? "sort-arrow-down" : '') + " " + (this.state.currentOrder === 'name' ? 'active' : ''), onClick: function () { return _this.orderByName(); } }, "Name"),
                    react_1.default.createElement("div", { className: (this.state.orderByDateDir === 'Ascending' ? 'sort-arrow sort-arrow-down' : 'sort-arrow') + " pr-4 " + (this.state.currentOrder === 'date' ? 'active' : ''), onClick: function () { return _this.orderByDate(); } }, "Date"),
                    react_1.default.createElement("div", { className: "pr-4" }, "Sort by:")))) : null,
            react_1.default.createElement("div", { className: "document-library-evidence" }, renderListItems()),
            react_1.default.createElement(FolderListModal_1.default, { open: this.state.moveModalOpen, onClose: this.moveFileModalClose, onContinue: this.moveMultipleDoc, anySelect: (_a = this.state) === null || _a === void 0 ? void 0 : _a.moveFolderData, cancleButton: this.props.DocumentLibraryCancelButton, moveButton: this.props.DocumentLibraryMoveButton },
                react_1.default.createElement(ListFolders_1.default, { HeaderText: this.props.DocumentLibraryMoveDocumentHeader, Folders: this.state.folderList.filter(function (x) { return x.Type === 'folder' && x.Name !== _this.state.ParentFolder; }), onFolderclick: this.onFolderSelect, selectFolder: (_c = (_b = this.state) === null || _b === void 0 ? void 0 : _b.moveFolderData) === null || _c === void 0 ? void 0 : _c.Id })),
            react_1.default.createElement(core_1.Dialog, { open: this.state.alertModal.open, onClose: this.alertModalClose, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description" },
                react_1.default.createElement(core_1.DialogTitle, { id: "alert-dialog-title" }, this.props.DocumentLibraryAreYouSure),
                react_1.default.createElement(core_1.DialogContent, null,
                    react_1.default.createElement(core_1.DialogContentText, { id: "alert-dialog-description" }, (_d = this.state.alertModal.message) !== null && _d !== void 0 ? _d : this.props.DocumentLibraryAlertMessage)),
                react_1.default.createElement(core_1.DialogActions, null,
                    react_1.default.createElement(core_1.Button, { onClick: this.alertModalClose }, "Cancel"),
                    !this.state.alertModal.error ? react_1.default.createElement(core_1.Button, { onClick: this.continueOnAlert }, this.props.DocumentLibraryContinueButton) : null))) :
            react_1.default.createElement("div", { className: 'loading' },
                react_1.default.createElement(core_1.CircularProgress, { className: 'spinner', style: { color: '#007C92' } }))));
    };
    return DocumentLibraryComponent;
}(react_1.Component));
exports.default = DocumentLibraryComponent;
